
import Vue from 'vue';
import axios from 'axios';
import Top from '@/components/templates/Top.vue';
import * as action from '@/store/actions';
interface Param {
  key: string;
  value: string;
}

export default Vue.extend({
  name: 'Params',
  components: {
    Top,
  },
  data() {
    return {
      params: [] as Param[],

      // Valores posibles para cada key
      optionsByKey: {
        'allowtransfer': ['yes', 'no'],
        'rewrite-contact': ['yes', 'no'],
        'rtp-symmetric': ['yes', 'no'],
        'remove_contact_existing': ['yes', 'no'],
        'view_cdr_not_completed': ['yes', 'no'],
        'webadmin': ['yes', 'no'],
        'webphone': ['yes', 'no'],
        'clickToCall': ['yes', 'no'],
        'checkCorp': ['yes', 'no'],
      } as Record<string, string[]>,
      descriptionsByKey: {
        'allowtransfer': '',
        'rewrite-contact': '',
        'rtp-symmetric': '',
        'remove_contact_existing': '',
        'view_cdr_not_completed': '',
        'webadmin': 'Habilita webadmin',
        'webphone': 'Habilita el WebPhone',
        'clickToCall': 'Habilita click-to-call',
        'checkCorp': 'Check para habilitar la edicion de corporaciones desde supervisor',
        'allow': '',
        'call-limit': '',
        'disallow': '',
        'dtmfmode': '',
        'exten-qualify': '',
        'language': '',
        'trunk-qualify': '',
        'webrtcserver': 'Servidor WebRTC asociado si esta vacio se usa servidor por defecto',
        'exten-ini': 'Número mínimo permitido para extensiones de tres digitos',
      } as Record<string, string>,
      // Claves que permiten escribir manualmente
      editableKeys: ['allow', 'call-limit', 'disallow', 'dtmfmode', 'exten-qualify', 'language', 'trunk-qualify', 'webrtcserver', 'exten-ini'],
    };
  },
  methods: {
    async fetchParams() {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get<Param[]>(action.GET_ALL_PARAMS, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const fetched = response.data;

        // Unificamos todas las claves posibles: keys de opciones + claves editables
        const expectedKeys = [
          ...Object.keys(this.optionsByKey),
          ...this.editableKeys,
        ];

        // Eliminamos duplicados (en caso de que estén en ambas listas)
        const uniqueKeys = [...new Set(expectedKeys)];

        // Generamos el array final asegurando que todos estén presentes
        this.params = uniqueKeys.map(key => {
          const existing = fetched.find(p => p.key === key);
          return {
            key,
            value: existing ? existing.value : '', // valor por defecto si no vino del backend
          };
        });

        // Si querés permitir agregar más personalizados manualmente:
        this.params.push(this.newEmptyParam());

      } catch (error) {
        console.error('Error al obtener los parámetros:', error);
      }
    },
    getOptionsForKey(key: string): string[] {
      return this.optionsByKey[key] || [];
    },
    isEditable(key: string): boolean {
      return this.editableKeys.includes(key);
    },
    hasOptions(key: string): boolean {
      return this.optionsByKey && Object.prototype.hasOwnProperty.call(this.optionsByKey, key);
    },
    async guardarCambios() {
      try {
        await this.$nextTick(); // <-- Esperar que se sincronicen los cambios

        const token = localStorage.getItem('token');
        const filtered = this.params.filter(p => p.key.trim() !== '');

        await axios.post(action.UPDATE_PARAMS, filtered, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        this.$emit('snackbar', { color: 'success', text: 'Parámetros guardados correctamente.' });
      } catch (error) {
        console.error('Error al guardar los parámetros:', error);
        this.$emit('snackbar', { color: 'error', text: 'Error al guardar los parámetros.' });
      }
    },
  },
  mounted() {
    this.fetchParams();
  },
});
